import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home__screen" }
const _hoisted_2 = { class: "home__page-content" }

import { useDataStore } from '@/stores/data';
import { onMounted, watch } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';
import MainDock from '@/components/TheMainDock.vue';
import TheMobileMenu from '@/components/TheMobileMenu.vue';
import { useBillingStore } from '@/stores/billing';
import { useDialogRouter } from '@/utils/hooks/use-dialog-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const dataStore = useDataStore()
const billingStore = useBillingStore()

onMounted(async () => {
  await dataStore.init()
  await billingStore.requestDetails()
})

const accountStore = useAccountStore()
const router = useRouter()
watch(() => accountStore.currentUser, (user) => {
  if (user && user.status_id === 0) {
    router.push("/auth/confirm")
  }
}, { immediate: true })

useDialogRouter()

// const dialogStore = useDialogStore()
// onMounted(() => {
//   dialogStore.open(ConnectSocialConfirmDialog)
// })


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainDock),
    _createVNode(TheMobileMenu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})